//@flow

import React from "react"
import { EntityList } from "../UI/EntityList"
import { PrimaryButton } from "../UI/Buttons"
import { Toolbar, Heading, SearchField } from "../UI/Toolbar"
import { Page } from "../UI/Page"
import Loader from "../UI/Loader"
import withSearchHandler from "./withSearchHandler"
import type { Props, SearchProps } from "./types"

type SearchTableProps = Props & SearchProps

class SearchTableView extends React.Component<SearchTableProps> {
  searchInput: Object

  render() {
    const {
      entityName,
      children,
      handleNewClick,
      loading,
      handleSearchChange,
      query,
      changed
    } = this.props
    return (
      <Page>
        <Toolbar>
          <Heading>{entityName}</Heading>
          {handleNewClick ? (
            <PrimaryButton onClick={handleNewClick}>New</PrimaryButton>
          ) : (
            ""
          )}
          <SearchField
            placeholder={`Search ${entityName}`}
            innerRef={input => (this.searchInput = input)}
            onChange={handleSearchChange}
            value={query}
          />
        </Toolbar>
        <Loader loading={loading || changed}>
          <EntityList>{children}</EntityList>
        </Loader>
      </Page>
    )
  }
}

export default withSearchHandler(SearchTableView)



// WEBPACK FOOTER //
// ./src/SearchTableView/SearchTableView.js